export const toAbsoluteUrl = (pathname: string) =>
  process.env.PUBLIC_URL + pathname;
export const toAbsoluteUrlImage = (pathname: string) =>
  process.env.REACT_APP_PUBLIC_IMAGE_URL + pathname;
export const toAbsoluteUrlAvatar = (pathname: string) =>
  process.env.REACT_APP_PUBLIC_AVATAR_IMAGE_URL + pathname;
